import categories from '~~/.cache/categories.json'

export default function ({ query, redirect }) {
  const { c = 0 } = query

  const oldCategorySelected = categories.find(cat =>
    String(cat.legacyId).split(',').includes(c)
  )

  if (oldCategorySelected?.id) {
    const { c, ...newQuery } = query

    return redirect(
      301,
      `/products/category/${oldCategorySelected.slug}`,
      newQuery
    )
  }
}
